var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRickHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29415",
    "data-name": "Group 29415",
    transform: "translate(-421.999 -422.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(421.999 422.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29406",
    "data-name": "Group 29406",
    transform: "translate(437.994 428.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50226",
    "data-name": "Path 50226",
    d: "M22.049,9.182h-.961a8.7,8.7,0,0,1-2.562-.366A11.9,11.9,0,0,1,20.264,5.43l.458-.595L19.99,4.7a12.928,12.928,0,0,0-1.327-.092,10.635,10.635,0,0,0-2.7.275,25.372,25.372,0,0,1-.32-3.02V1.4h-.458c-1.144,0-2.883,1.281-3.615,1.83C10.792,2.5,9.008.9,7.91.9L7.864.946H7.406V1.4a14.59,14.59,0,0,1-.366,3.2,20.79,20.79,0,0,1-3.569-.32L2.83,4.149l.092.641A11.4,11.4,0,0,0,4.386,8.908a10.759,10.759,0,0,0-2.929,1.739L1,11.059l.5.366c.732.5,1.235.869,1.647,1.144.458.275.458.458.824.778A10.13,10.13,0,0,1,2.1,14.765l-.595.366.641.412L4.2,16.733c-.046.275-.183.732-.32,1.785l-.137.732a13.47,13.47,0,0,0,4.118-1.373h7.321c.412.183,1.83,1.373,3.112,1.373h.549l-.137-.549c-.183-.778-.275-1.235-.32-1.51.641-.412,2.471-1.556,2.929-2.517l.275-.458-.5-.137a5.425,5.425,0,0,1-1.556-.732A10.309,10.309,0,0,0,21.82,9.869Z",
    transform: "translate(-1 -0.9)",
    fill: "#81d4fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50227",
    "data-name": "Path 50227",
    d: "M20.9,28a1.83,1.83,0,1,0,1.83,1.83A1.83,1.83,0,0,0,20.9,28ZM10.83,28a1.83,1.83,0,1,0,1.83,1.83A1.83,1.83,0,0,0,10.83,28Z",
    transform: "translate(-5.339 -15.599)",
    fill: "#bcaaa4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50228",
    "data-name": "Path 50228",
    d: "M18.033,11C15.242,11,13,13.471,13,17.04v4.347c0,3.615,2.242,6.086,5.033,6.086s5.033-2.471,5.033-6.04V17.086C23.067,13.471,20.825,11,18.033,11Z",
    transform: "translate(-7.509 -6.378)",
    fill: "#d7ccc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50229",
    "data-name": "Path 50229",
    d: "M21.791,37H19v.412c0,.549.229,1.144.732,1.236.046.549.32,1.1.869,1.1s.824-.549.915-1.1c.32-.092.686-.412.686-1.236V37Z",
    transform: "translate(-10.764 -20.481)",
    fill: "#43a047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50230",
    "data-name": "Path 50230",
    d: "M16.478,37.319a.44.44,0,0,1-.412-.32.476.476,0,0,1,.275-.595,11.766,11.766,0,0,1,3.34-.5,10.128,10.128,0,0,1,3.34.5.463.463,0,0,1-.32.869,11.617,11.617,0,0,0-6.132,0C16.569,37.319,16.524,37.319,16.478,37.319Z",
    transform: "translate(-9.156 -19.884)",
    fill: "#8d6e63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50231",
    "data-name": "Path 50231",
    d: "M22,26v2.059c0,.5.046,2.059.915,2.059s.915-1.556.915-2.059V26Z",
    transform: "translate(-12.391 -14.515)",
    fill: "#efebe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50232",
    "data-name": "Path 50232",
    d: "M26.059,21a2.059,2.059,0,1,0,2.059,2.059A2.059,2.059,0,0,0,26.059,21Z",
    transform: "translate(-13.475 -11.803)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50233",
    "data-name": "Path 50233",
    d: "M17.059,21a2.059,2.059,0,1,0,2.059,2.059A2.059,2.059,0,0,0,17.059,21Z",
    transform: "translate(-8.594 -11.803)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28957",
    "data-name": "Group 28957",
    transform: "translate(7.779 10.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50234",
    "data-name": "Path 50234",
    d: "M23.033,24a.458.458,0,1,0,.458.458A.458.458,0,0,0,23.033,24Zm-4.576.458a.458.458,0,1,0,.458.458A.458.458,0,0,0,18.458,24.458Z",
    transform: "translate(-18 -24)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28958",
    "data-name": "Group 28958",
    transform: "translate(6.398 8.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50235",
    "data-name": "Path 50235",
    d: "M19.108,20.409a6.241,6.241,0,0,1-1.693-.275A4.542,4.542,0,0,0,16.728,20a4.084,4.084,0,0,0-1.19,0,.471.471,0,0,1-.549-.32.5.5,0,0,1,.32-.549,4.882,4.882,0,0,1,1.556,0,6.24,6.24,0,0,1,.778.183,4.845,4.845,0,0,0,1.419.229,7.065,7.065,0,0,0,1.419-.229,6.24,6.24,0,0,1,.778-.183,4.882,4.882,0,0,1,1.556,0,.417.417,0,0,1,.32.549.471.471,0,0,1-.549.32,4.084,4.084,0,0,0-1.19,0q-.275.069-.686.137A5.048,5.048,0,0,1,19.108,20.409Z",
    transform: "translate(-14.981 -19.067)",
    fill: "#64b5f6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRickHighlighted);
export default __webpack_public_path__ + "static/media/rickHighlighted.214ea6229b529f234b39ffd5a18d2b44.svg";
export { ForwardRef as ReactComponent };